import {
  isAtLeastBizAdmin,
  useCurrentContext,
  useIsCsr,
  usePermissionCheck,
} from '@cartdotcom/auth'
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { Menu } from '../../Menu/Menu'
import { showHideMenuItems } from '../Shared/visibility.helper'
import { addBusinessIdParam } from './McmMenu.helpers'
import { mcmBaseMenu } from './McmMenu.menu'
import { McmMenuIds, McmMenuItemsVisibility } from './McmMenu.types'

export const McmMenu = () => {
  const enablePricing = useBooleanFlagValue('mcm-pricing-manager-users', false)
  const { currentOrganization, currentBusiness, roleName } = useCurrentContext()

  const isCsr = useIsCsr()

  const hasEmailSubscriptionsAccess = usePermissionCheck(
    'emailSubscriptions',
    currentBusiness.id,
    currentOrganization.id,
  )

  const urlParams = new URLSearchParams(window.location.search)
  const isMcmNav = urlParams.get('nav') === 'mcm'
  const baseUrl = isMcmNav ? `${process.env.NX_MCM_ORIGIN}` : ''

  const menu = currentBusiness?.id ? mcmBaseMenu(baseUrl) : []

  if (menu.length) {
    const mcmMenu = menu.find(item => item.id === McmMenuIds.MCM);
    const mcmSettingsMenu = menu.find(item => item.id === McmMenuIds.MCM_SETTINGS);

    const settingsMenuItems = mcmSettingsMenu.items.find(subItem => subItem.id === McmMenuIds.SETTINGS)?.items ?? [];

    const menuItemVisibilityChecks: McmMenuItemsVisibility[] = [
      {
        menuItems: mcmSettingsMenu.items,
        visibility: {
          [McmMenuIds.LEGACY]: enablePricing,
          [McmMenuIds.ADMIN]: isCsr
        }
      },
      {
        menuItems: settingsMenuItems,
        visibility: {
          [McmMenuIds.API]: isAtLeastBizAdmin(roleName),
          [McmMenuIds.EMAILS]: hasEmailSubscriptionsAccess,
        },
      },
    ]

    for (const check of menuItemVisibilityChecks) {
      showHideMenuItems(check.menuItems, check.visibility)
    }

    if (isMcmNav) {
      // for redirect back to MCM, pass the businessId in case it's changed
      menu.forEach((m) => addBusinessIdParam(m, currentBusiness?.id))
    }
  }

  return <Menu menuSections={menu} />
}
